import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { authApi } from '../services';
import Header from '../components/Header';

function ChangePasswordPage({ onNavigate }) {
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false
  });
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.newPassword.trim() || !formData.confirmPassword.trim()) {
      setError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    if (formData.newPassword.length < 8) {
      setError('Mật khẩu mới phải có ít nhất 8 ký tự');
      return;
    }

    // Validate password complexity
    const hasUpperCase = /[A-Z]/.test(formData.newPassword);
    const hasLowerCase = /[a-z]/.test(formData.newPassword);
    const hasNumbers = /\d/.test(formData.newPassword);
    const hasSpecialChar = /[@$!%*?&]/.test(formData.newPassword);

    if (!hasUpperCase) {
      setError('Mật khẩu phải có ít nhất 1 chữ hoa');
      return;
    }

    if (!hasLowerCase) {
      setError('Mật khẩu phải có ít nhất 1 chữ thường');
      return;
    }

    if (!hasNumbers) {
      setError('Mật khẩu phải có ít nhất 1 số');
      return;
    }

    if (!hasSpecialChar) {
      setError('Mật khẩu phải có ít nhất 1 ký tự đặc biệt (@$!%*?&)');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Mật khẩu xác nhận không khớp');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authApi.changePassword({
        new_password: formData.newPassword
      });
      console.log(response)
      if(response.ok){
        setSuccess(true);
        onNavigate('/');
      }
    } catch (error) {
      console.error('Change password error:', error);
      setError(error.response?.data?.message || 'Đổi mật khẩu thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  if (success) {
    return (
      <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 40 }}>
        <div style={{ background: '#fff', width: 320, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Header
            onCartClick={() => {
              onNavigate(-1);
            }}
            onMenuClick={() => {
              onNavigate("/");
            }}
          />
          
          <div style={{ marginTop: 100, textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#5b6754', marginBottom: 8 }}>
              Đổi mật khẩu thành công!
            </div>
            <div style={{ fontSize: 14, color: '#666', lineHeight: '1.5' }}>
              Mật khẩu của bạn đã được cập nhật. Bạn sẽ được chuyển về trang chủ trong giây lát.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 40 }}>
      <div style={{ background: '#fff', width: 320, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Header
          onCartClick={() => {
            onNavigate(-1);
          }}
          onMenuClick={() => {
            onNavigate("/");
          }}
        />
        
        <div style={{ marginTop: 100, marginBottom: 20, textAlign: 'center' }}>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#5b6754', marginBottom: 8 }}>
            Đổi mật khẩu lần đầu
          </div>
          <div style={{ fontSize: 14, color: '#666', lineHeight: '1.5' }}>
            Vui lòng đặt mật khẩu mới cho tài khoản của bạn
          </div>
        </div>
        
        <div style={{ width: '100%', marginBottom: 20 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Mật khẩu mới</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword.newPassword ? 'text' : 'password'} 
              name="newPassword"
              placeholder="Nhập mật khẩu mới" 
              style={{
                ...inputStyle,
                borderColor: error ? '#ff4444' : '#bfc3b7'
              }} 
              value={formData.newPassword} 
              onChange={handleInputChange}
            />
            <span onClick={() => togglePasswordVisibility('newPassword')} style={eyeIconStyle}>
              {showPassword.newPassword ? '🙈' : '👁️'}
            </span>
          </div>
        </div>
        
        <div style={{ width: '100%', marginBottom: 8 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Xác nhận mật khẩu mới</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword.confirmPassword ? 'text' : 'password'} 
              name="confirmPassword"
              placeholder="Nhập lại mật khẩu mới" 
              style={{
                ...inputStyle,
                borderColor: error ? '#ff4444' : '#bfc3b7'
              }} 
              value={formData.confirmPassword} 
              onChange={handleInputChange}
            />
            <span onClick={() => togglePasswordVisibility('confirmPassword')} style={eyeIconStyle}>
              {showPassword.confirmPassword ? '🙈' : '👁️'}
            </span>
          </div>
        </div>
        <div style={{ 
            fontSize: 12, 
            color: '#666', 
            marginTop: 4,
            marginBottom: 10,
            lineHeight: 1.4
          }}>
            Mật khẩu phải có ít nhất 8 ký tự, bao gồm: chữ hoa, chữ thường, số và ký tự đặc biệt (@$!%*?&)
          </div>
        
        {error && (
          <div style={{ 
            color: '#ff4444', 
            fontSize: 14, 
            marginBottom: 16,
            textAlign: 'center',
            background: '#fee',
            border: '1px solid #fcc',
            borderRadius: 8,
            padding: '8px 12px'
          }}>
            {error}
          </div>
        )}
        
        <div style={{ width: '100%', textAlign: 'right', marginBottom: 24 }}>
          <button 
            style={{
              ...btnStyle,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Đang đổi mật khẩu...' : 'Đổi mật khẩu'}
          </button>
        </div>
        
        <div style={{ marginTop: 32, fontSize: 14, fontWeight: 300, width: '100%', textAlign: 'center' }}>
          <span style={{ color: '#2a6be4', cursor: 'pointer' }} onClick={() => onNavigate('/')}>
            Quay về trang chủ
          </span>
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  height: 44,
  border: '1px solid #bfc3b7',
  borderRadius: 22,
  padding: '0 44px 0 16px',
  fontSize: 16,
  marginTop: 4,
  outline: 'none',
  boxSizing: 'border-box',
};

const btnStyle = {
  width: 135,
  height: 48,
  background: '#5b6754',
  color: '#fff',
  border: 'none',
  borderRadius: 24,
  fontSize: 16,
  margin: '12px 0',
  cursor: 'pointer',
  fontFamily: 'NeueEinstellung',
  fontWeight: 300,
  float: 'right',
};

const eyeIconStyle = {
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 20,
  cursor: 'pointer',
  userSelect: 'none',
};

export default ChangePasswordPage; 